import { ASK_ASPER_BASE_URL } from "../config";

function getAuthHeader(): string {
    const token = localStorage.getItem('accessToken');
    return `Bearer ${token}`;
}

/** Response shape from /list_sql_files */
interface ListSqlFilesResponse {
    latest_file_url: string | null;
    run_id?: string;
    message?: string;
}

/**
* Export a single artifact as Excel.
* GET /list_sql_files?session_id={thread_id}&run_id={run_id}
* Returns JSON with latest_file_url (SAS URL). We open the URL directly (anchor click)
* instead of fetch() to avoid CORS — Azure Blob Storage blocks cross-origin fetch from the browser.
*/
export async function exportArtifactAsExcel(
    threadId: string,
    runId: string,
    filename?: string
): Promise<void> {
    const params = new URLSearchParams({
        session_id: threadId,
        run_id: runId,
    });
    const response = await fetch(`${ASK_ASPER_BASE_URL}list_sql_files?${params.toString()}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: getAuthHeader(),
        },
    });

    if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    const data: ListSqlFilesResponse = await response.json();
    if (!data.latest_file_url) {
        throw new Error(data.message ?? 'No files found for the given session_id and run_id');
    }

    // Open SAS URL directly via navigation — no fetch, so no CORS. The browser downloads the file.
    const a = document.createElement('a');
    a.href = data.latest_file_url;
    a.download = filename ?? `artifact-${runId}.xlsx`;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.click();
}
 
/**
* Trigger browser download of a blob as a file
*/
export function triggerBlobDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();

    // Delay revoke so the browser has time to read the blob. Revoking too early
    // can cause corrupted downloads because the browser reads the URL asynchronously.
    setTimeout(() => {
        URL.revokeObjectURL(url);
    }, 500);
}